import { GraphQLClient, RequestDocument, Variables } from 'graphql-request';
import _ from 'lodash';
import { UserManager } from 'oidc-client-ts';

import { BACKEND_URI } from '@/config';
import { COGNITO_AUTH_CONFIG } from '@/providers/app';

import { ConnectionError, APIError } from './errors';

export const graphqlHeaders = {};

class CustomGraphQLClient extends GraphQLClient {
  request<T = any, V = Variables>(document: RequestDocument, variables?: V): Promise<T> {
    return new Promise((resolve, reject) => {
      const array = new Uint32Array(1);
      const rand = window.crypto.getRandomValues(array);
      const userManager = new UserManager(COGNITO_AUTH_CONFIG);
      userManager
        .getUser()
        .then((user) => {
          if (!user) {
            reject(new Error('COGNITO_AUTH_ERROR'));
          }
          const token = user?.access_token;
          super.setHeader('authorization', `Bearer ${token}`);
          super.setHeader('requestid', `${rand[0]}`);
          super
            .request(document, variables)
            .then((d) => {
              resolve(d);
            })
            .catch((e) => {
              if (e.response) {
                reject(
                  new APIError(_.get(e.response, 'errors[0].message'), _.get(e.response, 'errors'))
                );
              } else {
                reject(new ConnectionError(e.message));
              }
            });
        })
        .catch((e) => reject(e));
    });
  }
}

export const graphqlClient = new CustomGraphQLClient(BACKEND_URI);
export const useFetchData = <TData, TVariables>(
  query: string
): ((variables?: TVariables) => Promise<TData>) => {
  return async (variables?: TVariables) => {
    const operationName = extractOperationName(query);
    const startTime = performance.now();

    try {
      const result = await graphqlClient.request(query, variables);
      sendQueryMetric('graphql_query', operationName, startTime); // 成功時の計測値を送信
      return result;
    } catch (e) {
      sendQueryMetric('graphql_query_error', operationName, startTime); // 失敗時の計測値を送信
      throw e;
    }
  };
};
/** 経過時間を計算して gtag 送信する共通関数 */
const sendQueryMetric = (
  eventName: 'graphql_query' | 'graphql_query_error',
  opName: string,
  startTime: number
) => {
  const elapsed = Math.round(performance.now() - startTime); // ms
  (window as any).gtag?.('event', eventName, {
    event_category: 'GraphQL',
    event_label: opName,
    value: elapsed, // 成功・失敗どちらでも計測値を入れる
    non_interaction: true,
  });
};

const extractOperationName = (query: string): string => {
  const match = query.match(/\b(query|mutation)\s+(\w+)/);
  return match ? match[2] : 'unknown';
};
